var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "browser icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.8276 37.7544C67.8276 20.8076 55.9853 9.16951 40.2636 8.96533C24.4399 9.16951 13.4143 20.5014 11.3725 36.3251C17.0895 26.9329 28.4213 20.6034 38.426 20.6034C46.5931 20.6034 50.9829 24.9933 50.9829 33.6708H29.1359C29.5443 29.9956 31.1777 26.2183 33.4237 23.9724C24.644 27.5455 18.5187 35.5084 18.5187 46.2277C18.5187 59.4993 28.7276 70.2186 43.6325 70.2186C51.1871 70.2186 57.3124 68.5852 62.621 65.8288V52.8635C57.8229 55.722 52.1059 57.4575 45.7764 57.4575C36.2822 57.4575 29.4422 52.8635 29.4422 44.4922H67.8276V37.7544Z",
    fill: "#0078D7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/Edge.105816912c779dbbaf0090660180d2dc.svg";
export { ForwardRef as ReactComponent };